/* FarmSteady — search results completeness.
 *
 * Shopify's COMBINED storefront search blends result types by relevance and
 * silently drops lower-ranked pages/articles ("bagel" returns 2 of 7
 * instruction pages). Type-scoped searches return the full set, so after the
 * combined page paints we fetch ?type=article and ?type=page and swap in the
 * complete Recipes / Kit instructions / More groups (server-rendered by the
 * same section, imagery included), then refresh the chips and count.
 */
(function () {
  const root = document.querySelector('.fs-sr[data-terms]');
  if (!root) return;
  const terms = root.dataset.terms;
  if (!terms) return;

  const fetchDoc = (type) =>
    fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}search?q=${encodeURIComponent(terms)}&type=${type}`)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((t) => new DOMParser().parseFromString(t, 'text/html'))
      .catch(() => null);

  Promise.all([fetchDoc('article'), fetchDoc('page')]).then(([articleDoc, pageDoc]) => {
    const swaps = [];
    if (articleDoc) swaps.push(['sr-recipes', articleDoc]);
    if (pageDoc) {
      swaps.push(['sr-instructions', pageDoc]);
      swaps.push(['sr-other', pageDoc]);
    }

    const order = ['sr-products', 'sr-instructions', 'sr-recipes', 'sr-other'];
    let changed = false;

    for (const [id, doc] of swaps) {
      const fresh = doc.getElementById(id);
      if (!fresh) continue;
      const current = document.getElementById(id);
      if (current) {
        if (fresh.querySelectorAll('li').length > current.querySelectorAll('li').length) {
          current.replaceWith(fresh);
          changed = true;
        }
      } else {
        let anchor = null;
        for (let i = order.indexOf(id) - 1; i >= 0; i--) {
          anchor = document.getElementById(order[i]);
          if (anchor) break;
        }
        if (anchor) anchor.after(fresh);
        else root.appendChild(fresh);
        changed = true;
      }
    }

    // Relevance gate for instructions: Shopify matches page BODIES too, so a
    // "hot sauce" query surfaces every guide whose boilerplate mentions hot
    // water or sauce. Instruction pages are named after what they make —
    // require at least one query word in the TITLE.
    const words = terms.toLowerCase().split(/\s+/).filter(Boolean);
    let filtered = false;
    const instr = document.getElementById('sr-instructions');
    if (instr && words.length) {
      instr.querySelectorAll('li').forEach((li) => {
        const title = (li.querySelector('.fs-sr__instr-title') || li).textContent.toLowerCase();
        if (!words.some((w) => title.includes(w))) {
          li.remove();
          filtered = true;
        }
      });
      if (!instr.querySelector('li')) {
        instr.remove();
        filtered = true;
      }
    }

    // Products get the same title gate, but only when at least one product
    // title-matches — a "mozzarella" search legitimately finds the Italian
    // Fresh Cheese Kit through its body, and we keep that behavior when no
    // title carries the term.
    const prods = document.getElementById('sr-products');
    if (prods && words.length) {
      const rows = [...prods.querySelectorAll('li')];
      const matches = rows.filter((li) => {
        const title = (li.querySelector('.fs-rail-card__title') || li).textContent.toLowerCase();
        return words.some((w) => title.includes(w));
      });
      if (matches.length > 0 && matches.length < rows.length) {
        rows.forEach((li) => {
          if (!matches.includes(li)) li.remove();
        });
        filtered = true;
      }
    }

    if (!changed && !filtered) return;

    const present = [
      ['sr-products', 'Kits & mixes'],
      ['sr-instructions', 'Kit instructions'],
      ['sr-recipes', 'Recipes'],
    ]
      .map(([id, label]) => {
        const el = document.getElementById(id);
        return el ? { id, label, count: el.querySelectorAll('li').length } : null;
      })
      .filter(Boolean);

    let nav = root.querySelector('.fs-sr__nav');
    if (present.length > 1) {
      if (!nav) {
        nav = document.createElement('nav');
        nav.className = 'fs-sr__nav';
        nav.setAttribute('aria-label', 'Result types');
        document.getElementById(present[0].id).before(nav);
      }
      while (nav.firstChild) nav.removeChild(nav.firstChild);
      present.forEach((g) => {
        const chip = document.createElement('a');
        chip.className = 'fs-sr__nav-chip';
        chip.href = '#' + g.id;
        chip.appendChild(document.createTextNode(g.label + ' '));
        const count = document.createElement('span');
        count.textContent = String(g.count);
        chip.appendChild(count);
        nav.appendChild(chip);
      });
    }

    const eyebrow = root.querySelector('.fs-sr__eyebrow');
    if (eyebrow) {
      const other = document.getElementById('sr-other');
      const total =
        present.reduce((sum, g) => sum + g.count, 0) + (other ? other.querySelectorAll('li').length : 0);
      eyebrow.textContent = total + ' result' + (total === 1 ? '' : 's');
    }
  });
})();
